let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZ3om")).then(() => parcelRequire('aZLbL'));